import React, { useState } from 'react';
import { Context } from './hooks/contextHook'
import './App.css';
import MainPage from './containers/MainPage/mainpage';
import { makeStyles } from '@material-ui/core/styles';
import themeStyle from './util/themeStyle';
import createMuiTheme from '@material-ui/core/styles/createMuiStrictModeTheme';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import axios from 'axios';
import { API_URL } from './util/constants'

const theme = createMuiTheme(themeStyle)

function App() {
  axios.defaults.baseURL = API_URL;
  const [globalError, setGlobalError] = useState(false);
  const useStyles = makeStyles((theme) => ({
    root: {
       backgroundColor: '#E3EFFE',
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <MuiThemeProvider theme={theme}>
        <Context.Provider value={{ globalError, setGlobalError }}>
          <MainPage />
        </Context.Provider>
      </MuiThemeProvider>
    </div>
  );
}

export default App;
